<div class="notification-bell" *ngIf="isVisible">
  <button
    type="button"
    class="notification-bell-btn"
    [class.is-active]="isActive || isOpen"
    [attr.aria-label]="bellAriaLabel"
    [attr.aria-expanded]="isOpen"
    aria-haspopup="true"
    (click)="togglePanel($event)"
  >
    <i class="bi bi-bell" aria-hidden="true"></i>
    <span *ngIf="badgeLabel" class="notification-bell-badge">{{ badgeLabel }}</span>
  </button>

  <div
    class="notification-panel"
    *ngIf="isOpen"
    role="menu"
    aria-label="Notifications"
  >
    <div class="notification-panel-header">
      <span class="notification-panel-title">Notifications</span>
      <div class="notification-panel-actions">
        <button
          type="button"
          class="notification-mark-all"
          [disabled]="markingAll || unreadCount <= 0"
          (click)="onMarkAllAsRead($event)"
        >
          Mark all as read
        </button>
        <button
          type="button"
          class="notification-view-all"
          (click)="openFullPage($event)"
        >
          View all
        </button>
      </div>
    </div>

    <div class="notification-panel-body">
      <div *ngIf="isLoading" class="notification-state">Loading…</div>
      <div *ngIf="!isLoading && loadError" class="notification-state is-error">
        {{ loadError }}
      </div>
      <div
        *ngIf="!isLoading && !loadError && notifications.length === 0"
        class="notification-state"
      >
        No notifications
      </div>

      <ul
        *ngIf="!isLoading && !loadError && notifications.length > 0"
        class="notification-list"
      >
        <li
          *ngFor="let item of notifications; trackBy: trackById"
          class="notification-item"
          [class.is-unread]="!item.is_read"
        >
          <div class="notification-item-row">
            <button
              type="button"
              class="notification-row"
              role="menuitem"
              (click)="onRowClick(item, $event)"
            >
              <span class="notification-row-main">
                <span class="notification-row-title">{{ item.title }}</span>
                <span class="notification-row-body" *ngIf="truncateBody(item.body)">
                  {{ truncateBody(item.body) }}
                </span>
              </span>
              <span class="notification-row-meta">
                <span *ngIf="!item.is_read" class="notification-unread-dot" aria-hidden="true"></span>
                <time class="notification-row-time">{{ relativeTime(item.created_on) }}</time>
              </span>
            </button>
            <button
              type="button"
              class="notification-item-delete"
              [attr.aria-label]="'Delete ' + item.title"
              title="Delete"
              [disabled]="deletingId === item.notification_id"
              (click)="onDeleteOne(item, $event)"
            >
              <i class="bi bi-x" aria-hidden="true"></i>
            </button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
